import React from 'react';
import { formatNumber, formatPercent } from '../utils/formatters';
import { COLORS } from '../theme';

const FunnelChart = ({ data }) => {
  // Calcular totais (conversas iniciadas = action_type messaging_conversation_started_7d)
  const totals = data.reduce((acc, day) => ({
    impressions: acc.impressions + day.impressions,
    clicks: acc.clicks + day.clicks,
    conversations: acc.conversations + day.conversations
  }), { impressions: 0, clicks: 0, conversations: 0 });

  const ctr = totals.impressions > 0
    ? ((totals.clicks / totals.impressions) * 100).toFixed(2)
    : 0;

  const conversionRate = totals.clicks > 0
    ? ((totals.conversations / totals.clicks) * 100).toFixed(2)
    : 0;

  const overallConversionRate = totals.impressions > 0
    ? ((totals.conversations / totals.impressions) * 100).toFixed(2)
    : 0;

  const stages = [
    {
      name: 'Impressões',
      value: totals.impressions,
      color: COLORS.muted,
      width: 100,
      subtitle: 'Pessoas que viram seus anúncios'
    },
    {
      name: 'Cliques',
      value: totals.clicks,
      color: COLORS.accent,
      width: 70,
      subtitle: `${ctr}% das impressões`
    },
    {
      name: 'Conversas iniciadas',
      value: totals.conversations,
      color: COLORS.conversas,
      width: 42,
      subtitle: `${conversionRate}% dos cliques`
    }
  ];

  return (
    <div className="chart-card">
      <h3 className="chart-title">Funil de Conversão</h3>
      <div style={{ padding: '10px 0' }}>
        {stages.map((stage, index) => (
          <div key={index} style={{ marginBottom: '22px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px' }}>
              <div style={{
                width: `${stage.width}%`,
                background: `linear-gradient(135deg, ${stage.color}33 0%, ${stage.color}1a 100%)`,
                border: `1px solid ${stage.color}66`,
                padding: '18px',
                borderRadius: '10px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '13px', fontWeight: 600, color: stage.color, marginBottom: '5px' }}>
                  {stage.name}
                </div>
                <div style={{ fontSize: '26px', fontWeight: 700, color: COLORS.text, marginBottom: '3px' }}>
                  {formatNumber(stage.value)}
                </div>
                <div style={{ fontSize: '12px', color: COLORS.muted }}>
                  {stage.subtitle}
                </div>
              </div>
            </div>

            {index < stages.length - 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', margin: '8px 0' }}>
                <div style={{ width: 0, height: 0, borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderTop: `8px solid ${COLORS.border}` }} />
              </div>
            )}
          </div>
        ))}

        <div style={{
          marginTop: '24px',
          padding: '15px',
          background: COLORS.card,
          border: `1px solid ${COLORS.border}`,
          borderRadius: '10px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '13px', color: COLORS.muted, marginBottom: '8px' }}>
            Taxa de conversão geral
          </div>
          <div style={{ fontSize: '24px', fontWeight: 700, color: COLORS.conversas }}>
            {formatPercent(overallConversionRate)}
          </div>
          <div style={{ fontSize: '12px', color: COLORS.muted, marginTop: '5px' }}>
            De impressões para conversas iniciadas
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunnelChart;
